export default __webpack_public_path__ + "assets/e9b685c4ef3cb554512a834e5ec214f1.png";